(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiki-landing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',function(e){if(!e.target.matches('#qv-form input[name="pack"]'))return;document.getElementById('qv-id').value=e.target.value;document.getElementById('qv-display-price').textContent=e.target.dataset.price;document.getElementById('qv-selected-label').textContent=e.target.dataset.label});

  } catch(e) { console.error(e); }
})();
})();
